import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData<T> {
    infos: T;
}

@Component({
    selector: 'app-parkinginfo',
    templateUrl: './parkinginfo.component.html',
    styleUrls: ['./parkinginfo.component.scss'],
    standalone: false
})
export class ParkinginfoComponent implements OnInit {
    datas = {
        CarParkName: '',
        Transfer: '',
        Address: '',
        ShuttleTimes: '',
        ShuttleFrequency: '',
        Special: '',
        ArrivalProcedure: '',
        DepartureProcedure: '',
        CarSizeInfo: '',
        Accessibility: '',
        SecurityInfo: '',
        Insurance: '',
        ChildSeat: '',
        DirectionsShort: '',
        MinimumParkingDays: '',
        MaximumParkingDays: '',
    };

    title: string = '';
    currentImage:number = 0;
    currentImagePosition:number = 0;
    desktopTemplate:boolean = false;
    constructor (
        @Inject(MAT_DIALOG_DATA) public data: DialogData<any>,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit (): void {
        this.title = this.data?.infos?.description;
        this.currentImagePosition = this.currentImage;
        if (this.data?.infos) {
          this.data?.infos?.infoList.forEach(element => {
            if (element.value?.length > 0) {
                this.datas[String(element.key)] = element.value;
            }
          });
        }
        this.cdr.detectChanges();
    }
}
